<template>
  <div class="z-modal preventCloseParentModal fixed left-0 top-0 w-full h-full outline-none overflow-x-hidden
                                             overflow-y-auto !bg-black/40">
    <div class="bg-zt-normal absolute top-1/2 -translate-y-1/2 pb-4 mx-auto text-[14px] rounded-zt flex flex-col
                justify-center items-center left-1/2 -translate-x-1/2 w-[350px] xl:w-[479px]">
      <div class="relative py-4 px-5 w-full border-b-[1px] border-[#313A44] flex flex-nowrap items-center">
        <span class="font-semibold text-base mr-8">{{this.modalHeaderText}}</span>
        <div class="x-close-modal" @click="this.$emit('cancel')"></div>
      </div>
      <div v-if="this.modalBodyText.length > 0" class="font-medium my-4 px-5 w-full" v-html="this.modalBodyText"></div>
      <div class="flex gap-x-3 mt-4 px-2 xl:gap-x-6 xl:px-5 xl:justify-between" :class="{ '!w-full' :buttonsOnEdges }">
        <button @click="this.$emit('cancel')"
                class="zt-button-transparent w-40">
          {{this.cancelButtonText}}
        </button>
        <button @click="this.$emit('confirm')"
                class="zt-button w-40">
          {{this.confirmButtonText}}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import utils_mixin from "../../mixins/utils_mixin";
export default {
  name: 'ConfirmationModal',
  mixins: [utils_mixin],
  emits: ['cancel', 'confirm'],
	props: {
		modalHeaderText: String,
		confirmButtonText: String,
		cancelButtonText: String,
		modalBodyText: String,
		buttonsOnEdges: Boolean,
	}
}
</script>

<style scoped>

</style>